import { cn } from "@msuite/ui/utils";
import { Daily } from "@/components/plan/daily";
import { usePlanStore } from "@/components/plan/store";

export function Dailies() {
	/** Store */
	const currentWeek = usePlanStore((state) => state.currentWeek);
	const showResources = usePlanStore((state) => state.showResources);
	const dates = currentWeek.weekDatesDb();

	/** Render */
	return (
		<div
			className={cn(
				"dailies",
				"h-stack overflow-x-auto h-full items-stretch",
				"snap-x snap-mandatory",
				!showResources && "pr-4",
			)}
		>
			{dates?.map((date, dayIndex) => (
				<Daily
					key={date}
					date={date}
					dayIndex={dayIndex}
				/>
			))}
		</div>
	);
}
